import React from "react";

interface TabSelectorProps {
  isList: boolean;
  onClickTab: (type: string) => void;
}

const TabSelector: React.FC<TabSelectorProps> = ({ isList, onClickTab }) => {
  return (
    <div className="">
      <div className="flex justify-center">
        <div
          className={`w-[50%] text-center py-4 text-lg font-bold cursor-pointer ${
            isList
              ? "bg-[#fff] text-[#1562fc]"
              : "bg-[#F4F5F7] text-[#BBBDC0] font-normal"
          } `}
          onClick={() => onClickTab("LIST")}
        >
          리스트 둘러보기
        </div>
        <div
          className={`w-[50%] text-center py-4 text-lg font-bold cursor-pointer ${
            !isList
              ? "bg-[#fff] text-[#1562fc]"
              : "bg-[#F4F5F7] text-[#BBBDC0] font-normal"
          } `}
          onClick={() => onClickTab("MAP")}
        >
          지도로 찾아보기
        </div>
      </div>
    </div>
  );
};

export default TabSelector;
